import React, { MutableRefObject, MouseEventHandler } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import icons from '@core/Icons';
import IconListComponent from './Icon-list.component';

interface IProps {
    deviceIconNum: number;
    iconSelectVisible: boolean;
    iconSelectEl: HTMLButtonElement | null;
    iconSelectRef: MutableRefObject<HTMLButtonElement | null>;
    onSelectIconBtnClick: MouseEventHandler<HTMLButtonElement>;
    onSelectIconWindowClose: (e: MouseEvent | TouchEvent) => void;
    onIconClick: MouseEventHandler<HTMLButtonElement>;
}

const Component: React.FC<IProps> = ({
    deviceIconNum,
    iconSelectVisible,
    iconSelectEl,
    iconSelectRef,
    onSelectIconBtnClick,
    onSelectIconWindowClose,
    onIconClick,
}: IProps) => {
    const currentIconFilename = icons.getIcon(deviceIconNum);
    const currentIconSrc = `public/img/svg/${currentIconFilename}`;
    return (
        <>
            <Box className="edit-device__icon-wrap">
                <Button
                    className="edit-device__icon-btn"
                    ref={iconSelectRef}
                    onClick={onSelectIconBtnClick}
                    onKeyDown={(e) => {
                        const { key } = e;
                        if (key === 'Enter') {
                            e.stopPropagation();
                            e.preventDefault();
                            if (iconSelectRef && iconSelectRef.current)
                                iconSelectRef.current.click();
                        }
                    }}
                >
                    <Box
                        className="edit-device__icon-ico"
                        component="img"
                        alt="device icon"
                        src={currentIconSrc}
                    />
                </Button>
            </Box>
            <IconListComponent
                iconList={icons.iconList}
                onIconClick={onIconClick}
                onSelectIconWindowClose={onSelectIconWindowClose}
                iconSelectVisible={iconSelectVisible}
                iconSelectEl={iconSelectEl}
            />
        </>
    );
};

const IconSelectComponent = React.memo(Component);

export default IconSelectComponent;
